/**
 * Homepage-only floating header: sticks to the viewport and becomes
 * an inset rounded bar after a short scroll.
 */
(function () {
  const header = document.querySelector('.cp-landing__header--float');
  if (!header) return;

  const landing = header.closest('.cp-landing');
  const threshold = 16;
  let ticking = false;

  function setOffset() {
    if (!landing) return;

    const wasFloating = header.classList.contains('is-floating');
    if (wasFloating) {
      header.classList.remove('is-floating');
    }

    const height = Math.ceil(header.getBoundingClientRect().height);
    landing.style.setProperty('--cp-float-header-h', `${height}px`);

    if (wasFloating) {
      header.classList.add('is-floating');
    }
  }

  function updateFloating() {
    header.classList.toggle('is-floating', window.scrollY > threshold);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      updateFloating();
      ticking = false;
    });
  }

  setOffset();
  updateFloating();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener(
    'resize',
    () => {
      setOffset();
      updateFloating();
    },
    { passive: true }
  );
})();
